// biome-ignore lint/style/noRestrictedImports: encapsulation
import { getTime as getTime_ } from "date-fns";

import type { Time } from "../time";

// Overload the date-fns/getTime function to gracefully handle undefined and null values.

export function getTime(time: Time): number;
export function getTime(time: undefined | null | Time): undefined | number;
export function getTime(time: undefined | null | Time): undefined | number {
	return time == null ? undefined : getTime_(time);
}
